// Get OpsManager Dashboard Data
export const GET_OPS_MANAGER_DASHBOARD_REQUEST = 'GET_OPS_MANAGER_DASHBOARD_REQUEST';
export const GET_OPS_MANAGER_DASHBOARD_SUCCESS = 'GET_OPS_MANAGER_DASHBOARD_SUCCESS';
export const GET_OPS_MANAGER_DASHBOARD_FAILURE = 'GET_OPS_MANAGER_DASHBOARD_FAILURE';

// Get Team Members (Internal Users)
export const GET_TEAM_MEMBERS_REQUEST = 'GET_TEAM_MEMBERS_REQUEST';
export const GET_TEAM_MEMBERS_SUCCESS = 'GET_TEAM_MEMBERS_SUCCESS';
export const GET_TEAM_MEMBERS_FAILURE = 'GET_TEAM_MEMBERS_FAILURE';
